/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable max-lines */
/* eslint-disable global-require */
import keyBy from 'lodash/keyBy';

export const PRIORITY_COUNTRIES_CODES = ['RU', 'KZ', 'BY', 'AM', 'UZ', 'UA', 'GE', 'AZ', 'TJ', 'KG', 'MD', 'TM'];

type TranslationsKeys = 'ru' | 'en'

export type Country = {
    image: any;
    translations: Record<TranslationsKeys, string>;
    countryCode: string;
    countryCallingCode: string;
};

type CountriesType = Record<string, Country>;

export const COUNTRIES: CountriesType = {
    US: {
        image: require('../../icons/flags/US.png'),
        countryCallingCode: '1',
        countryCode: 'US',
        translations: {
            en: 'United States of America',
            ru: 'США',
        },
    },
    AD: {
        image: require('../../icons/flags/AD.png'),
        countryCallingCode: '376',
        countryCode: 'AD',
        translations: {
            en: 'Andorra',
            ru: 'Андорра',
        },
    },
    AE: {
        image: require('../../icons/flags/AE.png'),
        countryCallingCode: '971',
        countryCode: 'AE',
        translations: {
            en: 'United Arab Emirates',
            ru: 'ОАЭ',
        },
    },
    AF: {
        image: require('../../icons/flags/AF.png'),
        countryCallingCode: '93',
        countryCode: 'AF',
        translations: {
            en: 'Afghanistan',
            ru: 'Афганистан',
        },
    },
    AG: {
        image: require('../../icons/flags/AG.png'),
        countryCallingCode: '1',
        countryCode: 'AG',
        translations: {
            en: 'Antigua and Barbuda',
            ru: 'Антигуа и Барбуда',
        },
    },
    AI: {
        image: require('../../icons/flags/AI.png'),
        countryCallingCode: '1',
        countryCode: 'AI',
        translations: {
            en: 'Anguilla',
            ru: 'Ангилья',
        },
    },
    AL: {
        image: require('../../icons/flags/AL.png'),
        countryCallingCode: '355',
        countryCode: 'AL',
        translations: {
            en: 'Albania',
            ru: 'Албания',
        },
    },
    AM: {
        image: require('../../icons/flags/AM.png'),
        countryCallingCode: '374',
        countryCode: 'AM',
        translations: {
            en: 'Armenia',
            ru: 'Армения',
        },
    },
    AO: {
        image: require('../../icons/flags/AO.png'),
        countryCallingCode: '244',
        countryCode: 'AO',
        translations: {
            en: 'Angola',
            ru: 'Ангола',
        },
    },
    AR: {
        image: require('../../icons/flags/AR.png'),
        countryCallingCode: '54',
        countryCode: 'AR',
        translations: {
            en: 'Argentina',
            ru: 'Аргентина',
        },
    },
    AT: {
        image: require('../../icons/flags/AT.png'),
        countryCallingCode: '43',
        countryCode: 'AT',
        translations: {
            en: 'Austria',
            ru: 'Австрия',
        },
    },
    AU: {
        image: require('../../icons/flags/AU.png'),
        countryCallingCode: '61',
        countryCode: 'AU',
        translations: {
            en: 'Australia',
            ru: 'Австралия',
        },
    },
    AW: {
        image: require('../../icons/flags/AW.png'),
        countryCallingCode: '297',
        countryCode: 'AW',
        translations: {
            en: 'Aruba',
            ru: 'Аруба',
        },
    },
    AX: {
        image: require('../../icons/flags/AX.png'),
        countryCallingCode: '358',
        countryCode: 'AX',
        translations: {
            en: 'Åland Islands',
            ru: 'Аландские острова',
        },
    },
    AZ: {
        image: require('../../icons/flags/AZ.png'),
        countryCallingCode: '994',
        countryCode: 'AZ',
        translations: {
            en: 'Azerbaijan',
            ru: 'Азербайджан',
        },
    },
    BA: {
        image: require('../../icons/flags/BA.png'),
        countryCallingCode: '387',
        countryCode: 'BA',
        translations: {
            en: 'Bosnia and Herzegovina',
            ru: 'Босния и Герцеговина',
        },
    },
    BB: {
        image: require('../../icons/flags/BB.png'),
        countryCallingCode: '1',
        countryCode: 'BB',
        translations: {
            en: 'Barbados',
            ru: 'Барбадос',
        },
    },
    BD: {
        image: require('../../icons/flags/BD.png'),
        countryCallingCode: '880',
        countryCode: 'BD',
        translations: {
            en: 'Bangladesh',
            ru: 'Бангладеш',
        },
    },
    BE: {
        image: require('../../icons/flags/BE.png'),
        countryCallingCode: '32',
        countryCode: 'BE',
        translations: {
            en: 'Belgium',
            ru: 'Бельгия',
        },
    },
    BF: {
        image: require('../../icons/flags/BF.png'),
        countryCallingCode: '226',
        countryCode: 'BF',
        translations: {
            en: 'Burkina Faso',
            ru: 'Буркина-Фасо',
        },
    },
    BG: {
        image: require('../../icons/flags/BG.png'),
        countryCallingCode: '359',
        countryCode: 'BG',
        translations: {
            en: 'Bulgaria',
            ru: 'Болгария',
        },
    },
    BH: {
        image: require('../../icons/flags/BH.png'),
        countryCallingCode: '973',
        countryCode: 'BH',
        translations: {
            en: 'Bahrain',
            ru: 'Бахрейн',
        },
    },
    BI: {
        image: require('../../icons/flags/BI.png'),
        countryCallingCode: '257',
        countryCode: 'BI',
        translations: {
            en: 'Burundi',
            ru: 'Бурунди',
        },
    },
    BJ: {
        image: require('../../icons/flags/BJ.png'),
        countryCallingCode: '229',
        countryCode: 'BJ',
        translations: {
            en: 'Benin',
            ru: 'Бенин',
        },
    },
    BM: {
        image: require('../../icons/flags/BM.png'),
        countryCallingCode: '1',
        countryCode: 'BM',
        translations: {
            en: 'Bermuda',
            ru: 'Бермуды',
        },
    },
    BN: {
        image: require('../../icons/flags/BN.png'),
        countryCallingCode: '673',
        countryCode: 'BN',
        translations: {
            en: 'Brunei Darussalam',
            ru: 'Бруней',
        },
    },
    BO: {
        image: require('../../icons/flags/BO.png'),
        countryCallingCode: '591',
        countryCode: 'BO',
        translations: {
            en: 'Bolivia',
            ru: 'Боливия',
        },
    },
    BR: {
        image: require('../../icons/flags/BR.png'),
        countryCallingCode: '55',
        countryCode: 'BR',
        translations: {
            en: 'Brazil',
            ru: 'Бразилия',
        },
    },
    BS: {
        image: require('../../icons/flags/BS.png'),
        countryCallingCode: '1',
        countryCode: 'BS',
        translations: {
            en: 'Bahamas',
            ru: 'Багамы',
        },
    },
    BT: {
        image: require('../../icons/flags/BT.png'),
        countryCallingCode: '975',
        countryCode: 'BT',
        translations: {
            en: 'Bhutan',
            ru: 'Бутан',
        },
    },
    BW: {
        image: require('../../icons/flags/BW.png'),
        countryCallingCode: '267',
        countryCode: 'BW',
        translations: {
            en: 'Botswana',
            ru: 'Ботсвана',
        },
    },
    BY: {
        image: require('../../icons/flags/BY.png'),
        countryCallingCode: '375',
        countryCode: 'BY',
        translations: {
            en: 'Belarus',
            ru: 'Беларусь',
        },
    },
    BZ: {
        image: require('../../icons/flags/BZ.png'),
        countryCallingCode: '501',
        countryCode: 'BZ',
        translations: {
            en: 'Belize',
            ru: 'Белиз',
        },
    },
    CA: {
        image: require('../../icons/flags/CA.png'),
        countryCallingCode: '1',
        countryCode: 'CA',
        translations: {
            en: 'Canada',
            ru: 'Канада',
        },
    },
    CD: {
        image: require('../../icons/flags/CD.png'),
        countryCallingCode: '243',
        countryCode: 'CD',
        translations: {
            en: 'Democratic Republic of the Congo',
            ru: 'Демократическая Республика Конго',
        },
    },
    CF: {
        image: require('../../icons/flags/CF.png'),
        countryCallingCode: '236',
        countryCode: 'CF',
        translations: {
            en: 'Central African Republic',
            ru: 'ЦАР',
        },
    },
    CG: {
        image: require('../../icons/flags/CG.png'),
        countryCallingCode: '242',
        countryCode: 'CG',
        translations: {
            en: 'Republic of the Congo',
            ru: 'Республика Конго',
        },
    },
    CH: {
        image: require('../../icons/flags/CH.png'),
        countryCallingCode: '41',
        countryCode: 'CH',
        translations: {
            en: 'Switzerland',
            ru: 'Швейцария',
        },
    },
    CI: {
        image: require('../../icons/flags/CI.png'),
        countryCallingCode: '225',
        countryCode: 'CI',
        translations: {
            en: "Cote D'Ivoire",
            ru: 'Кот-д’Ивуар',
        },
    },
    CL: {
        image: require('../../icons/flags/CL.png'),
        countryCallingCode: '56',
        countryCode: 'CL',
        translations: {
            en: 'Chile',
            ru: 'Чили',
        },
    },
    CM: {
        image: require('../../icons/flags/CM.png'),
        countryCallingCode: '237',
        countryCode: 'CM',
        translations: {
            en: 'Cameroon',
            ru: 'Камерун',
        },
    },
    CN: {
        image: require('../../icons/flags/CN.png'),
        countryCallingCode: '86',
        countryCode: 'CN',
        translations: {
            en: "People's Republic of China",
            ru: 'КНР (Китайская Народная Республика)',
        },
    },
    CO: {
        image: require('../../icons/flags/CO.png'),
        countryCallingCode: '57',
        countryCode: 'CO',
        translations: {
            en: 'Colombia',
            ru: 'Колумбия',
        },
    },
    CR: {
        image: require('../../icons/flags/CR.png'),
        countryCallingCode: '506',
        countryCode: 'CR',
        translations: {
            en: 'Costa Rica',
            ru: 'Коста-Рика',
        },
    },
    CU: {
        image: require('../../icons/flags/CU.png'),
        countryCallingCode: '53',
        countryCode: 'CU',
        translations: {
            en: 'Cuba',
            ru: 'Куба',
        },
    },
    CV: {
        image: require('../../icons/flags/CV.png'),
        countryCallingCode: '238',
        countryCode: 'CV',
        translations: {
            en: 'Cape Verde',
            ru: 'Кабо-Верде',
        },
    },
    CY: {
        image: require('../../icons/flags/CY.png'),
        countryCallingCode: '357',
        countryCode: 'CY',
        translations: {
            en: 'Cyprus',
            ru: 'Кипр',
        },
    },
    CZ: {
        image: require('../../icons/flags/CZ.png'),
        countryCallingCode: '420',
        countryCode: 'CZ',
        translations: {
            en: 'Czech Republic',
            ru: 'Чехия',
        },
    },
    DE: {
        image: require('../../icons/flags/DE.png'),
        countryCallingCode: '49',
        countryCode: 'DE',
        translations: {
            en: 'Germany',
            ru: 'Германия',
        },
    },
    DJ: {
        image: require('../../icons/flags/DJ.png'),
        countryCallingCode: '253',
        countryCode: 'DJ',
        translations: {
            en: 'Djibouti',
            ru: 'Джибути',
        },
    },
    DK: {
        image: require('../../icons/flags/DK.png'),
        countryCallingCode: '45',
        countryCode: 'DK',
        translations: {
            en: 'Denmark',
            ru: 'Дания',
        },
    },
    DM: {
        image: require('../../icons/flags/DM.png'),
        countryCallingCode: '1',
        countryCode: 'DM',
        translations: {
            en: 'Dominica',
            ru: 'Доминика',
        },
    },
    DO: {
        image: require('../../icons/flags/DO.png'),
        countryCallingCode: '1',
        countryCode: 'DO',
        translations: {
            en: 'Dominican Republic',
            ru: 'Доминиканская Республика',
        },
    },
    DZ: {
        image: require('../../icons/flags/DZ.png'),
        countryCallingCode: '213',
        countryCode: 'DZ',
        translations: {
            en: 'Algeria',
            ru: 'Алжир',
        },
    },
    EC: {
        image: require('../../icons/flags/EC.png'),
        countryCallingCode: '593',
        countryCode: 'EC',
        translations: {
            en: 'Ecuador',
            ru: 'Эквадор',
        },
    },
    EE: {
        image: require('../../icons/flags/EE.png'),
        countryCallingCode: '372',
        countryCode: 'EE',
        translations: {
            en: 'Estonia',
            ru: 'Эстония',
        },
    },
    EG: {
        image: require('../../icons/flags/EG.png'),
        countryCallingCode: '20',
        countryCode: 'EG',
        translations: {
            en: 'Egypt',
            ru: 'Египет',
        },
    },
    ER: {
        image: require('../../icons/flags/ER.png'),
        countryCallingCode: '291',
        countryCode: 'ER',
        translations: {
            en: 'Eritrea',
            ru: 'Эритрея',
        },
    },
    ES: {
        image: require('../../icons/flags/ES.png'),
        countryCallingCode: '34',
        countryCode: 'ES',
        translations: {
            en: 'Spain',
            ru: 'Испания',
        },
    },
    ET: {
        image: require('../../icons/flags/ET.png'),
        countryCallingCode: '251',
        countryCode: 'ET',
        translations: {
            en: 'Ethiopia',
            ru: 'Эфиопия',
        },
    },
    FI: {
        image: require('../../icons/flags/FI.png'),
        countryCallingCode: '358',
        countryCode: 'FI',
        translations: {
            en: 'Finland',
            ru: 'Финляндия',
        },
    },
    FJ: {
        image: require('../../icons/flags/FJ.png'),
        countryCallingCode: '679',
        countryCode: 'FJ',
        translations: {
            en: 'Fiji',
            ru: 'Фиджи',
        },
    },
    FK: {
        image: require('../../icons/flags/FK.png'),
        countryCallingCode: '500',
        countryCode: 'FK',
        translations: {
            en: 'Falkland Islands (Malvinas)',
            ru: 'Фолклендские острова',
        },
    },
    FM: {
        image: require('../../icons/flags/FM.png'),
        countryCallingCode: '691',
        countryCode: 'FM',
        translations: {
            en: 'Federated States of Micronesia',
            ru: 'Микронезия',
        },
    },
    FR: {
        image: require('../../icons/flags/FR.png'),
        countryCallingCode: '33',
        countryCode: 'FR',
        translations: {
            en: 'France',
            ru: 'Франция',
        },
    },
    GA: {
        image: require('../../icons/flags/GA.png'),
        countryCallingCode: '241',
        countryCode: 'GA',
        translations: {
            en: 'Gabon',
            ru: 'Габон',
        },
    },
    GB: {
        image: require('../../icons/flags/GB.png'),
        countryCallingCode: '44',
        countryCode: 'GB',
        translations: {
            en: 'United Kingdom',
            ru: 'Великобритания',
        },
    },
    GD: {
        image: require('../../icons/flags/GD.png'),
        countryCallingCode: '1',
        countryCode: 'GD',
        translations: {
            en: 'Grenada',
            ru: 'Гренада',
        },
    },
    GE: {
        image: require('../../icons/flags/GE.png'),
        countryCallingCode: '995',
        countryCode: 'GE',
        translations: {
            en: 'Georgia',
            ru: 'Грузия',
        },
    },
    GG: {
        image: require('../../icons/flags/GG.png'),
        countryCallingCode: '44',
        countryCode: 'GG',
        translations: {
            en: 'Guernsey',
            ru: 'Гернси',
        },
    },
    GH: {
        image: require('../../icons/flags/GH.png'),
        countryCallingCode: '233',
        countryCode: 'GH',
        translations: {
            en: 'Ghana',
            ru: 'Гана',
        },
    },
    GI: {
        image: require('../../icons/flags/GI.png'),
        countryCallingCode: '350',
        countryCode: 'GI',
        translations: {
            en: 'Gibraltar',
            ru: 'Гибралтар',
        },
    },
    GL: {
        image: require('../../icons/flags/GL.png'),
        countryCallingCode: '299',
        countryCode: 'GL',
        translations: {
            en: 'Greenland',
            ru: 'Гренландия',
        },
    },
    GM: {
        image: require('../../icons/flags/GM.png'),
        countryCallingCode: '220',
        countryCode: 'GM',
        translations: {
            en: 'Republic of The Gambia',
            ru: 'Гамбия',
        },
    },
    GN: {
        image: require('../../icons/flags/GN.png'),
        countryCallingCode: '224',
        countryCode: 'GN',
        translations: {
            en: 'Guinea',
            ru: 'Гвинея',
        },
    },
    GQ: {
        image: require('../../icons/flags/GQ.png'),
        countryCallingCode: '240',
        countryCode: 'GQ',
        translations: {
            en: 'Equatorial Guinea',
            ru: 'Экваториальная Гвинея',
        },
    },
    GR: {
        image: require('../../icons/flags/GR.png'),
        countryCallingCode: '30',
        countryCode: 'GR',
        translations: {
            en: 'Greece',
            ru: 'Греция',
        },
    },
    GT: {
        image: require('../../icons/flags/GT.png'),
        countryCallingCode: '502',
        countryCode: 'GT',
        translations: {
            en: 'Guatemala',
            ru: 'Гватемала',
        },
    },
    GW: {
        image: require('../../icons/flags/GW.png'),
        countryCallingCode: '245',
        countryCode: 'GW',
        translations: {
            en: 'Guinea-Bissau',
            ru: 'Гвинея-Бисау',
        },
    },
    GY: {
        image: require('../../icons/flags/GY.png'),
        countryCallingCode: '592',
        countryCode: 'GY',
        translations: {
            en: 'Guyana',
            ru: 'Гайана',
        },
    },
    HK: {
        image: require('../../icons/flags/HK.png'),
        countryCallingCode: '852',
        countryCode: 'HK',
        translations: {
            en: 'Hong Kong',
            ru: 'Гонконг',
        },
    },
    HN: {
        image: require('../../icons/flags/HN.png'),
        countryCallingCode: '504',
        countryCode: 'HN',
        translations: {
            en: 'Honduras',
            ru: 'Гондурас',
        },
    },
    HR: {
        image: require('../../icons/flags/HR.png'),
        countryCallingCode: '385',
        countryCode: 'HR',
        translations: {
            en: 'Croatia',
            ru: 'Хорватия',
        },
    },
    HT: {
        image: require('../../icons/flags/HT.png'),
        countryCallingCode: '509',
        countryCode: 'HT',
        translations: {
            en: 'Haiti',
            ru: 'Гаити',
        },
    },
    HU: {
        image: require('../../icons/flags/HU.png'),
        countryCallingCode: '36',
        countryCode: 'HU',
        translations: {
            en: 'Hungary',
            ru: 'Венгрия',
        },
    },
    ID: {
        image: require('../../icons/flags/ID.png'),
        countryCallingCode: '62',
        countryCode: 'ID',
        translations: {
            en: 'Indonesia',
            ru: 'Индонезия',
        },
    },
    IE: {
        image: require('../../icons/flags/IE.png'),
        countryCallingCode: '353',
        countryCode: 'IE',
        translations: {
            en: 'Ireland',
            ru: 'Ирландия',
        },
    },
    IL: {
        image: require('../../icons/flags/IL.png'),
        countryCallingCode: '972',
        countryCode: 'IL',
        translations: {
            en: 'Israel',
            ru: 'Израиль',
        },
    },
    IM: {
        image: require('../../icons/flags/IM.png'),
        countryCallingCode: '44',
        countryCode: 'IM',
        translations: {
            en: 'Isle of Man',
            ru: 'Остров Мэн',
        },
    },
    IN: {
        image: require('../../icons/flags/IN.png'),
        countryCallingCode: '91',
        countryCode: 'IN',
        translations: {
            en: 'India',
            ru: 'Индия',
        },
    },
    IQ: {
        image: require('../../icons/flags/IQ.png'),
        countryCallingCode: '964',
        countryCode: 'IQ',
        translations: {
            en: 'Iraq',
            ru: 'Ирак',
        },
    },
    IR: {
        image: require('../../icons/flags/IR.png'),
        countryCallingCode: '98',
        countryCode: 'IR',
        translations: {
            en: 'Islamic Republic of Iran',
            ru: 'Иран',
        },
    },
    IS: {
        image: require('../../icons/flags/IS.png'),
        countryCallingCode: '354',
        countryCode: 'IS',
        translations: {
            en: 'Iceland',
            ru: 'Исландия',
        },
    },
    IT: {
        image: require('../../icons/flags/IT.png'),
        countryCallingCode: '39',
        countryCode: 'IT',
        translations: {
            en: 'Italy',
            ru: 'Италия',
        },
    },
    JE: {
        image: require('../../icons/flags/JE.png'),
        countryCallingCode: '44',
        countryCode: 'JE',
        translations: {
            en: 'Jersey',
            ru: 'Джерси',
        },
    },
    JM: {
        image: require('../../icons/flags/JM.png'),
        countryCallingCode: '1',
        countryCode: 'JM',
        translations: {
            en: 'Jamaica',
            ru: 'Ямайка',
        },
    },
    JO: {
        image: require('../../icons/flags/JO.png'),
        countryCallingCode: '962',
        countryCode: 'JO',
        translations: {
            en: 'Jordan',
            ru: 'Иордания',
        },
    },
    JP: {
        image: require('../../icons/flags/JP.png'),
        countryCallingCode: '81',
        countryCode: 'JP',
        translations: {
            en: 'Japan',
            ru: 'Япония',
        },
    },
    KE: {
        image: require('../../icons/flags/KE.png'),
        countryCallingCode: '254',
        countryCode: 'KE',
        translations: {
            en: 'Kenya',
            ru: 'Кения',
        },
    },
    KG: {
        image: require('../../icons/flags/KG.png'),
        countryCallingCode: '996',
        countryCode: 'KG',
        translations: {
            en: 'Kyrgyzstan',
            ru: 'Киргизия',
        },
    },
    KH: {
        image: require('../../icons/flags/KH.png'),
        countryCallingCode: '855',
        countryCode: 'KH',
        translations: {
            en: 'Cambodia',
            ru: 'Камбоджа',
        },
    },
    KM: {
        image: require('../../icons/flags/KM.png'),
        countryCallingCode: '269',
        countryCode: 'KM',
        translations: {
            en: 'Comoros',
            ru: 'Коморы',
        },
    },
    KN: {
        image: require('../../icons/flags/KN.png'),
        countryCallingCode: '1',
        countryCode: 'KN',
        translations: {
            en: 'Saint Kitts and Nevis',
            ru: 'Сент-Китс и Невис',
        },
    },
    KP: {
        image: require('../../icons/flags/KP.png'),
        countryCallingCode: '850',
        countryCode: 'KP',
        translations: {
            en: 'North Korea',
            ru: 'КНДР (Корейская Народно-Демократическая Республика)',
        },
    },
    KR: {
        image: require('../../icons/flags/KR.png'),
        countryCallingCode: '82',
        countryCode: 'KR',
        translations: {
            en: 'South Korea',
            ru: 'Республика Корея',
        },
    },
    KW: {
        image: require('../../icons/flags/KW.png'),
        countryCallingCode: '965',
        countryCode: 'KW',
        translations: {
            en: 'Kuwait',
            ru: 'Кувейт',
        },
    },
    KY: {
        image: require('../../icons/flags/KY.png'),
        countryCallingCode: '1',
        countryCode: 'KY',
        translations: {
            en: 'Cayman Islands',
            ru: 'Острова Кайман',
        },
    },
    RU: {
        image: require('../../icons/flags/RU.png'),
        countryCallingCode: '7',
        countryCode: 'RU',
        translations: {
            en: 'Russian Federation',
            ru: 'Российская Федерация',
        },
    },
    KZ: {
        image: require('../../icons/flags/KZ.png'),
        countryCallingCode: '7',
        countryCode: 'KZ',
        translations: {
            en: 'Kazakhstan',
            ru: 'Казахстан',
        },
    },
    LA: {
        image: require('../../icons/flags/LA.png'),
        countryCallingCode: '856',
        countryCode: 'LA',
        translations: {
            en: "Lao People's Democratic Republic",
            ru: 'Лаос',
        },
    },
    LB: {
        image: require('../../icons/flags/LB.png'),
        countryCallingCode: '961',
        countryCode: 'LB',
        translations: {
            en: 'Lebanon',
            ru: 'Ливан',
        },
    },
    LC: {
        image: require('../../icons/flags/LC.png'),
        countryCallingCode: '1',
        countryCode: 'LC',
        translations: {
            en: 'Saint Lucia',
            ru: 'Сент-Люсия',
        },
    },
    LI: {
        image: require('../../icons/flags/LI.png'),
        countryCallingCode: '423',
        countryCode: 'LI',
        translations: {
            en: 'Liechtenstein',
            ru: 'Лихтенштейн',
        },
    },
    LK: {
        image: require('../../icons/flags/LK.png'),
        countryCallingCode: '94',
        countryCode: 'LK',
        translations: {
            en: 'Sri Lanka',
            ru: 'Шри-Ланка',
        },
    },
    LR: {
        image: require('../../icons/flags/LR.png'),
        countryCallingCode: '231',
        countryCode: 'LR',
        translations: {
            en: 'Liberia',
            ru: 'Либерия',
        },
    },
    LS: {
        image: require('../../icons/flags/LS.png'),
        countryCallingCode: '266',
        countryCode: 'LS',
        translations: {
            en: 'Lesotho',
            ru: 'Лесото',
        },
    },
    LT: {
        image: require('../../icons/flags/LT.png'),
        countryCallingCode: '370',
        countryCode: 'LT',
        translations: {
            en: 'Lithuania',
            ru: 'Литва',
        },
    },
    LU: {
        image: require('../../icons/flags/LU.png'),
        countryCallingCode: '352',
        countryCode: 'LU',
        translations: {
            en: 'Luxembourg',
            ru: 'Люксембург',
        },
    },
    LV: {
        image: require('../../icons/flags/LV.png'),
        countryCallingCode: '371',
        countryCode: 'LV',
        translations: {
            en: 'Latvia',
            ru: 'Латвия',
        },
    },
    LY: {
        image: require('../../icons/flags/LY.png'),
        countryCallingCode: '218',
        countryCode: 'LY',
        translations: {
            en: 'Libya',
            ru: 'Ливия',
        },
    },
    MA: {
        image: require('../../icons/flags/MA.png'),
        countryCallingCode: '212',
        countryCode: 'MA',
        translations: {
            en: 'Morocco',
            ru: 'Марокко',
        },
    },
    MC: {
        image: require('../../icons/flags/MC.png'),
        countryCallingCode: '377',
        countryCode: 'MC',
        translations: {
            en: 'Monaco',
            ru: 'Монако',
        },
    },
    MD: {
        image: require('../../icons/flags/MD.png'),
        countryCallingCode: '373',
        countryCode: 'MD',
        translations: {
            en: 'Republic of Moldova',
            ru: 'Молдавия',
        },
    },
    ME: {
        image: require('../../icons/flags/ME.png'),
        countryCallingCode: '382',
        countryCode: 'ME',
        translations: {
            en: 'Montenegro',
            ru: 'Черногория',
        },
    },
    MG: {
        image: require('../../icons/flags/MG.png'),
        countryCallingCode: '261',
        countryCode: 'MG',
        translations: {
            en: 'Madagascar',
            ru: 'Мадагаскар',
        },
    },
    MK: {
        image: require('../../icons/flags/MK.png'),
        countryCallingCode: '389',
        countryCode: 'MK',
        translations: {
            en: 'The Republic of North Macedonia',
            ru: 'Северная Македония',
        },
    },
    ML: {
        image: require('../../icons/flags/ML.png'),
        countryCallingCode: '223',
        countryCode: 'ML',
        translations: {
            en: 'Mali',
            ru: 'Мали',
        },
    },
    MM: {
        image: require('../../icons/flags/MM.png'),
        countryCallingCode: '95',
        countryCode: 'MM',
        translations: {
            en: 'Myanmar',
            ru: 'Мьянма',
        },
    },
    MN: {
        image: require('../../icons/flags/MN.png'),
        countryCallingCode: '976',
        countryCode: 'MN',
        translations: {
            en: 'Mongolia',
            ru: 'Монголия',
        },
    },
    MO: {
        image: require('../../icons/flags/MO.png'),
        countryCallingCode: '853',
        countryCode: 'MO',
        translations: {
            en: 'Macao',
            ru: 'Макао',
        },
    },
    MR: {
        image: require('../../icons/flags/MR.png'),
        countryCallingCode: '222',
        countryCode: 'MR',
        translations: {
            en: 'Mauritania',
            ru: 'Мавритания',
        },
    },
    MS: {
        image: require('../../icons/flags/MS.png'),
        countryCallingCode: '1',
        countryCode: 'MS',
        translations: {
            en: 'Montserrat',
            ru: 'Монтсеррат',
        },
    },
    MT: {
        image: require('../../icons/flags/MT.png'),
        countryCallingCode: '356',
        countryCode: 'MT',
        translations: {
            en: 'Malta',
            ru: 'Мальта',
        },
    },
    MU: {
        image: require('../../icons/flags/MU.png'),
        countryCallingCode: '230',
        countryCode: 'MU',
        translations: {
            en: 'Mauritius',
            ru: 'Маврикий',
        },
    },
    MV: {
        image: require('../../icons/flags/MV.png'),
        countryCallingCode: '960',
        countryCode: 'MV',
        translations: {
            en: 'Maldives',
            ru: 'Мальдивы',
        },
    },
    MW: {
        image: require('../../icons/flags/MW.png'),
        countryCallingCode: '265',
        countryCode: 'MW',
        translations: {
            en: 'Malawi',
            ru: 'Малави',
        },
    },
    MX: {
        image: require('../../icons/flags/MX.png'),
        countryCallingCode: '52',
        countryCode: 'MX',
        translations: {
            en: 'Mexico',
            ru: 'Мексика',
        },
    },
    MY: {
        image: require('../../icons/flags/MY.png'),
        countryCallingCode: '60',
        countryCode: 'MY',
        translations: {
            en: 'Malaysia',
            ru: 'Малайзия',
        },
    },
    MZ: {
        image: require('../../icons/flags/MZ.png'),
        countryCallingCode: '258',
        countryCode: 'MZ',
        translations: {
            en: 'Mozambique',
            ru: 'Мозамбик',
        },
    },
    NA: {
        image: require('../../icons/flags/NA.png'),
        countryCallingCode: '264',
        countryCode: 'NA',
        translations: {
            en: 'Namibia',
            ru: 'Намибия',
        },
    },
    NE: {
        image: require('../../icons/flags/NE.png'),
        countryCallingCode: '227',
        countryCode: 'NE',
        translations: {
            en: 'Niger',
            ru: 'Нигер',
        },
    },
    NG: {
        image: require('../../icons/flags/NG.png'),
        countryCallingCode: '234',
        countryCode: 'NG',
        translations: {
            en: 'Nigeria',
            ru: 'Нигерия',
        },
    },
    NI: {
        image: require('../../icons/flags/NI.png'),
        countryCallingCode: '505',
        countryCode: 'NI',
        translations: {
            en: 'Nicaragua',
            ru: 'Никарагуа',
        },
    },
    NL: {
        image: require('../../icons/flags/NL.png'),
        countryCallingCode: '31',
        countryCode: 'NL',
        translations: {
            en: 'Netherlands',
            ru: 'Нидерланды',
        },
    },
    NO: {
        image: require('../../icons/flags/NO.png'),
        countryCallingCode: '47',
        countryCode: 'NO',
        translations: {
            en: 'Norway',
            ru: 'Норвегия',
        },
    },
    NP: {
        image: require('../../icons/flags/NP.png'),
        countryCallingCode: '977',
        countryCode: 'NP',
        translations: {
            en: 'Nepal',
            ru: 'Непал',
        },
    },
    NZ: {
        image: require('../../icons/flags/NZ.png'),
        countryCallingCode: '64',
        countryCode: 'NZ',
        translations: {
            en: 'New Zealand',
            ru: 'Новая Зеландия',
        },
    },
    OM: {
        image: require('../../icons/flags/OM.png'),
        countryCallingCode: '968',
        countryCode: 'OM',
        translations: {
            en: 'Oman',
            ru: 'Оман',
        },
    },
    PA: {
        image: require('../../icons/flags/PA.png'),
        countryCallingCode: '507',
        countryCode: 'PA',
        translations: {
            en: 'Panama',
            ru: 'Панама',
        },
    },
    PE: {
        image: require('../../icons/flags/PE.png'),
        countryCallingCode: '51',
        countryCode: 'PE',
        translations: {
            en: 'Peru',
            ru: 'Перу',
        },
    },
    PF: {
        image: require('../../icons/flags/PF.png'),
        countryCallingCode: '689',
        countryCode: 'PF',
        translations: {
            en: 'French Polynesia',
            ru: 'Французская Полинезия',
        },
    },
    PG: {
        image: require('../../icons/flags/PG.png'),
        countryCallingCode: '675',
        countryCode: 'PG',
        translations: {
            en: 'Papua New Guinea',
            ru: 'Папуа — Новая Гвинея',
        },
    },
    PH: {
        image: require('../../icons/flags/PH.png'),
        countryCallingCode: '63',
        countryCode: 'PH',
        translations: {
            en: 'Philippines',
            ru: 'Филиппины',
        },
    },
    PK: {
        image: require('../../icons/flags/PK.png'),
        countryCallingCode: '92',
        countryCode: 'PK',
        translations: {
            en: 'Pakistan',
            ru: 'Пакистан',
        },
    },
    PL: {
        image: require('../../icons/flags/PL.png'),
        countryCallingCode: '48',
        countryCode: 'PL',
        translations: {
            en: 'Poland',
            ru: 'Польша',
        },
    },
    PR: {
        image: require('../../icons/flags/PR.png'),
        countryCallingCode: '1',
        countryCode: 'PR',
        translations: {
            en: 'Puerto Rico',
            ru: 'Пуэрто-Рико',
        },
    },
    PT: {
        image: require('../../icons/flags/PT.png'),
        countryCallingCode: '351',
        countryCode: 'PT',
        translations: {
            en: 'Portugal',
            ru: 'Португалия',
        },
    },
    PW: {
        image: require('../../icons/flags/PW.png'),
        countryCallingCode: '680',
        countryCode: 'PW',
        translations: {
            en: 'Palau',
            ru: 'Палау',
        },
    },
    PY: {
        image: require('../../icons/flags/PY.png'),
        countryCallingCode: '595',
        countryCode: 'PY',
        translations: {
            en: 'Paraguay',
            ru: 'Парагвай',
        },
    },
    QA: {
        image: require('../../icons/flags/QA.png'),
        countryCallingCode: '974',
        countryCode: 'QA',
        translations: {
            en: 'Qatar',
            ru: 'Катар',
        },
    },
    RO: {
        image: require('../../icons/flags/RO.png'),
        countryCallingCode: '40',
        countryCode: 'RO',
        translations: {
            en: 'Romania',
            ru: 'Румыния',
        },
    },
    RS: {
        image: require('../../icons/flags/RS.png'),
        countryCallingCode: '381',
        countryCode: 'RS',
        translations: {
            en: 'Serbia',
            ru: 'Сербия',
        },
    },
    RW: {
        image: require('../../icons/flags/RW.png'),
        countryCallingCode: '250',
        countryCode: 'RW',
        translations: {
            en: 'Rwanda',
            ru: 'Руанда',
        },
    },
    SA: {
        image: require('../../icons/flags/SA.png'),
        countryCallingCode: '966',
        countryCode: 'SA',
        translations: {
            en: 'Saudi Arabia',
            ru: 'Саудовская Аравия',
        },
    },
    SB: {
        image: require('../../icons/flags/SB.png'),
        countryCallingCode: '677',
        countryCode: 'SB',
        translations: {
            en: 'Solomon Islands',
            ru: 'Соломоновы Острова',
        },
    },
    SC: {
        image: require('../../icons/flags/SC.png'),
        countryCallingCode: '248',
        countryCode: 'SC',
        translations: {
            en: 'Seychelles',
            ru: 'Сейшельские Острова',
        },
    },
    SD: {
        image: require('../../icons/flags/SD.png'),
        countryCallingCode: '249',
        countryCode: 'SD',
        translations: {
            en: 'Sudan',
            ru: 'Судан',
        },
    },
    SE: {
        image: require('../../icons/flags/SE.png'),
        countryCallingCode: '46',
        countryCode: 'SE',
        translations: {
            en: 'Sweden',
            ru: 'Швеция',
        },
    },
    SG: {
        image: require('../../icons/flags/SG.png'),
        countryCallingCode: '65',
        countryCode: 'SG',
        translations: {
            en: 'Singapore',
            ru: 'Сингапур',
        },
    },
    SH: {
        image: require('../../icons/flags/SH.png'),
        countryCallingCode: '290',
        countryCode: 'SH',
        translations: {
            en: 'Saint Helena',
            ru: 'Острова Святой Елены, Вознесения и Тристан-да-Кунья',
        },
    },
    SI: {
        image: require('../../icons/flags/SI.png'),
        countryCallingCode: '386',
        countryCode: 'SI',
        translations: {
            en: 'Slovenia',
            ru: 'Словения',
        },
    },
    SK: {
        image: require('../../icons/flags/SK.png'),
        countryCallingCode: '421',
        countryCode: 'SK',
        translations: {
            en: 'Slovakia',
            ru: 'Словакия',
        },
    },
    SL: {
        image: require('../../icons/flags/SL.png'),
        countryCallingCode: '232',
        countryCode: 'SL',
        translations: {
            en: 'Sierra Leone',
            ru: 'Сьерра-Леоне',
        },
    },
    SM: {
        image: require('../../icons/flags/SM.png'),
        countryCallingCode: '378',
        countryCode: 'SM',
        translations: {
            en: 'San Marino',
            ru: 'Сан-Марино',
        },
    },
    SN: {
        image: require('../../icons/flags/SN.png'),
        countryCallingCode: '221',
        countryCode: 'SN',
        translations: {
            en: 'Senegal',
            ru: 'Сенегал',
        },
    },
    SO: {
        image: require('../../icons/flags/SO.png'),
        countryCallingCode: '252',
        countryCode: 'SO',
        translations: {
            en: 'Somalia',
            ru: 'Сомали',
        },
    },
    SR: {
        image: require('../../icons/flags/SR.png'),
        countryCallingCode: '597',
        countryCode: 'SR',
        translations: {
            en: 'Suriname',
            ru: 'Суринам',
        },
    },
    ST: {
        image: require('../../icons/flags/ST.png'),
        countryCallingCode: '239',
        countryCode: 'ST',
        translations: {
            en: 'Sao Tome and Principe',
            ru: 'Сан-Томе и Принсипи',
        },
    },
    SV: {
        image: require('../../icons/flags/SV.png'),
        countryCallingCode: '503',
        countryCode: 'SV',
        translations: {
            en: 'El Salvador',
            ru: 'Сальвадор',
        },
    },
    SY: {
        image: require('../../icons/flags/SY.png'),
        countryCallingCode: '963',
        countryCode: 'SY',
        translations: {
            en: 'Syrian Arab Republic',
            ru: 'Сирия',
        },
    },
    SZ: {
        image: require('../../icons/flags/SZ.png'),
        countryCallingCode: '268',
        countryCode: 'SZ',
        translations: {
            en: 'Eswatini',
            ru: 'Эсватини',
        },
    },
    TC: {
        image: require('../../icons/flags/TC.png'),
        countryCallingCode: '1',
        countryCode: 'TC',
        translations: {
            en: 'Turks and Caicos Islands',
            ru: 'Теркс и Кайкос',
        },
    },
    TD: {
        image: require('../../icons/flags/TD.png'),
        countryCallingCode: '235',
        countryCode: 'TD',
        translations: {
            en: 'Chad',
            ru: 'Чад',
        },
    },
    TG: {
        image: require('../../icons/flags/TG.png'),
        countryCallingCode: '228',
        countryCode: 'TG',
        translations: {
            en: 'Togo',
            ru: 'Того',
        },
    },
    TH: {
        image: require('../../icons/flags/TH.png'),
        countryCallingCode: '66',
        countryCode: 'TH',
        translations: {
            en: 'Thailand',
            ru: 'Таиланд',
        },
    },
    TJ: {
        image: require('../../icons/flags/TJ.png'),
        countryCallingCode: '992',
        countryCode: 'TJ',
        translations: {
            en: 'Tajikistan',
            ru: 'Таджикистан',
        },
    },
    TL: {
        image: require('../../icons/flags/TL.png'),
        countryCallingCode: '670',
        countryCode: 'TL',
        translations: {
            en: 'Timor-Leste',
            ru: 'Восточный Тимор',
        },
    },
    TM: {
        image: require('../../icons/flags/TM.png'),
        countryCallingCode: '993',
        countryCode: 'TM',
        translations: {
            en: 'Turkmenistan',
            ru: 'Туркмения',
        },
    },
    TN: {
        image: require('../../icons/flags/TN.png'),
        countryCallingCode: '216',
        countryCode: 'TN',
        translations: {
            en: 'Tunisia',
            ru: 'Тунис',
        },
    },
    TO: {
        image: require('../../icons/flags/TO.png'),
        countryCallingCode: '676',
        countryCode: 'TO',
        translations: {
            en: 'Tonga',
            ru: 'Тонга',
        },
    },
    TR: {
        image: require('../../icons/flags/TR.png'),
        countryCallingCode: '90',
        countryCode: 'TR',
        translations: {
            en: 'Türkiye',
            ru: 'Турция',
        },
    },
    TT: {
        image: require('../../icons/flags/TT.png'),
        countryCallingCode: '1',
        countryCode: 'TT',
        translations: {
            en: 'Trinidad and Tobago',
            ru: 'Тринидад и Тобаго',
        },
    },
    TW: {
        image: require('../../icons/flags/TW.png'),
        countryCallingCode: '886',
        countryCode: 'TW',
        translations: {
            en: 'Taiwan, Province of China',
            ru: 'Тайвань',
        },
    },
    TZ: {
        image: require('../../icons/flags/TZ.png'),
        countryCallingCode: '255',
        countryCode: 'TZ',
        translations: {
            en: 'United Republic of Tanzania',
            ru: 'Танзания',
        },
    },
    UA: {
        image: require('../../icons/flags/UA.png'),
        countryCallingCode: '380',
        countryCode: 'UA',
        translations: {
            en: 'Ukraine',
            ru: 'Украина',
        },
    },
    UG: {
        image: require('../../icons/flags/UG.png'),
        countryCallingCode: '256',
        countryCode: 'UG',
        translations: {
            en: 'Uganda',
            ru: 'Уганда',
        },
    },
    UY: {
        image: require('../../icons/flags/UY.png'),
        countryCallingCode: '598',
        countryCode: 'UY',
        translations: {
            en: 'Uruguay',
            ru: 'Уругвай',
        },
    },
    UZ: {
        image: require('../../icons/flags/UZ.png'),
        countryCallingCode: '998',
        countryCode: 'UZ',
        translations: {
            en: 'Uzbekistan',
            ru: 'Узбекистан',
        },
    },
    VC: {
        image: require('../../icons/flags/VC.png'),
        countryCallingCode: '1',
        countryCode: 'VC',
        translations: {
            en: 'Saint Vincent and the Grenadines',
            ru: 'Сент-Винсент и Гренадины',
        },
    },
    VE: {
        image: require('../../icons/flags/VE.png'),
        countryCallingCode: '58',
        countryCode: 'VE',
        translations: {
            en: 'Venezuela',
            ru: 'Венесуэла',
        },
    },
    VG: {
        image: require('../../icons/flags/VG.png'),
        countryCallingCode: '1',
        countryCode: 'VG',
        translations: {
            en: 'Virgin Islands, British',
            ru: 'Виргинские Острова (Великобритания)',
        },
    },
    VN: {
        image: require('../../icons/flags/VN.png'),
        countryCallingCode: '84',
        countryCode: 'VN',
        translations: {
            en: 'Vietnam',
            ru: 'Вьетнам',
        },
    },
    VU: {
        image: require('../../icons/flags/VU.png'),
        countryCallingCode: '678',
        countryCode: 'VU',
        translations: {
            en: 'Vanuatu',
            ru: 'Вануату',
        },
    },
    WS: {
        image: require('../../icons/flags/WS.png'),
        countryCallingCode: '685',
        countryCode: 'WS',
        translations: {
            en: 'Samoa',
            ru: 'Самоа',
        },
    },
    XK: {
        image: require('../../icons/flags/XK.png'),
        countryCallingCode: '383',
        countryCode: 'XK',
        translations: {
            en: 'Kosovo',
            ru: 'Косово',
        },
    },
    YE: {
        image: require('../../icons/flags/YE.png'),
        countryCallingCode: '967',
        countryCode: 'YE',
        translations: {
            en: 'Yemen',
            ru: 'Йемен',
        },
    },
    ZA: {
        image: require('../../icons/flags/ZA.png'),
        countryCallingCode: '27',
        countryCode: 'ZA',
        translations: {
            en: 'South Africa',
            ru: 'ЮАР',
        },
    },
    ZM: {
        image: require('../../icons/flags/ZM.png'),
        countryCallingCode: '260',
        countryCode: 'ZM',
        translations: {
            en: 'Zambia',
            ru: 'Замбия',
        },
    },
    ZW: {
        image: require('../../icons/flags/ZW.png'),
        countryCallingCode: '263',
        countryCode: 'ZW',
        translations: {
            en: 'Zimbabwe',
            ru: 'Зимбабве',
        },
    },
};

export const COUNTRIES_BY_CALLING_CODE_MAP = keyBy(COUNTRIES, 'countryCallingCode');
